import { render, staticRenderFns } from "./LayoutFuncionarioAdmin.vue?vue&type=template&id=fbfbe756&scoped=true&"
import script from "./LayoutFuncionarioAdmin.vue?vue&type=script&lang=js&"
export * from "./LayoutFuncionarioAdmin.vue?vue&type=script&lang=js&"
import style0 from "./LayoutFuncionarioAdmin.vue?vue&type=style&index=0&id=fbfbe756&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbfbe756",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContent } from 'vuetify/lib/components/VContent';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContent,VRow})
